import { Link } from "react-router-dom";
import { Wordmark } from "./Logo";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-white/10 bg-[#050507]" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-5 py-16 sm:px-8">
        <div className="flex flex-col gap-12 md:flex-row md:items-start md:justify-between">
          <div className="max-w-sm">
            <Wordmark />
            <p className="mt-5 text-sm leading-relaxed text-neutral-400">
              Drive a Better Tomorrow. प्रीमियम डीज़ल SUV — नई सोच, नए रास्तों के लिए।
            </p>
            <p className="mt-6 font-mono2 text-[11px] uppercase tracking-[0.3em] text-[#e6b800]/80">
              2.0L / 3.0L Diesel — RWD / AWD — BS6 Phase 2
            </p>
          </div>

          <div className="flex gap-16 sm:gap-24">
            <div>
              <p className="font-mono2 text-[11px] uppercase tracking-[0.25em] text-neutral-500">Explore</p>
              <ul className="mt-4 space-y-3 text-sm">
                <li><Link to="/" data-testid="footer-link-home" className="text-neutral-300 transition-colors hover:text-[#e6b800]">Home</Link></li>
                <li><Link to="/features" data-testid="footer-link-features" className="text-neutral-300 transition-colors hover:text-[#e6b800]">Features</Link></li>
                <li><Link to="/gallery" data-testid="footer-link-gallery" className="text-neutral-300 transition-colors hover:text-[#e6b800]">Gallery</Link></li>
                <li><Link to="/electric" data-testid="footer-link-electric" className="text-neutral-300 transition-colors hover:text-[#e6b800]">Electric</Link></li>
              </ul>
            </div>
            <div>
              <p className="font-mono2 text-[11px] uppercase tracking-[0.25em] text-neutral-500">Reserve</p>
              <ul className="mt-4 space-y-3 text-sm">
                <li>
                  <Link to="/booking" data-testid="footer-link-booking" className="text-neutral-300 transition-colors hover:text-[#e6b800]">
                    Pre-book IshuCar
                  </Link>
                </li>
                <li>
                  <Link to="/admin" data-testid="footer-link-admin" className="text-neutral-300 transition-colors hover:text-[#e6b800]">
                    Owner Login
                  </Link>
                </li>
                <li>
                  <Link to="/manual" data-testid="footer-link-manual" className="text-neutral-300 transition-colors hover:text-[#e6b800]">
                    E-Book Manual
                  </Link>
                </li>
                <li className="text-neutral-500">Refundable token ₹10,000</li>
                <li className="text-neutral-500">Priority delivery queue</li>
              </ul>
            </div>
            <div>
              <p className="font-mono2 text-[11px] uppercase tracking-[0.25em] text-neutral-500">Company</p>
              <ul className="mt-4 space-y-3 text-sm">
                <li><Link to="/about" data-testid="footer-link-about" className="text-neutral-300 transition-colors hover:text-[#e6b800]">About Us</Link></li>
                <li><Link to="/contact" data-testid="footer-link-contact" className="text-neutral-300 transition-colors hover:text-[#e6b800]">Contact</Link></li>
                <li><Link to="/refund-policy" data-testid="footer-link-refund" className="text-neutral-300 transition-colors hover:text-[#e6b800]">Refund Policy</Link></li>
                <li><Link to="/privacy-policy" data-testid="footer-link-privacy" className="text-neutral-300 transition-colors hover:text-[#e6b800]">Privacy Policy</Link></li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-start justify-between gap-3 border-t border-white/5 pt-7 sm:flex-row sm:items-center">
          <p className="text-xs text-neutral-600">© {year} IshuKart. All rights reserved.</p>
          <p className="font-mono2 text-[10px] uppercase tracking-[0.3em] text-neutral-600">
            100% Electric — Zero Emission
          </p>
        </div>
      </div>
    </footer>
  );
}